// Bugfix 31 en 32 (#1403, #1559): de oefeningkiezer van de schema-editor.
// Zoeken op naam en filteren op spiergroep gebeurt in de browser. Klikken
// meldt "oefening-kiezer:kies"; slepen geeft de oefening mee aan de sessie,
// die hem op de plek van neerzetten toevoegt (zie schema_editor_controller).
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["zoek", "chip", "optie", "leeg", "sessie"]

  connect() {
    this.groep = ""
  }

  filter() {
    const zoek = this.hasZoekTarget ? this.zoekTarget.value.trim().toLowerCase() : ""
    let zichtbaar = 0
    this.optieTargets.forEach((optie) => {
      const past = (zoek === "" || optie.dataset.naam.includes(zoek)) &&
        (this.groep === "" || optie.dataset.categorie === this.groep)
      optie.hidden = !past
      if (past) zichtbaar += 1
    })
    if (this.hasLeegTarget) this.leegTarget.hidden = zichtbaar > 0
  }

  kiesGroep(event) {
    this.groep = event.currentTarget.dataset.categorie || ""
    this.chipTargets.forEach((chip) => chip.setAttribute("aria-pressed", chip === event.currentTarget ? "true" : "false"))
    this.filter()
  }

  kies(event) {
    const knop = event.currentTarget
    this.dispatch("kies", { detail: { id: knop.dataset.id, naam: knop.dataset.naam } })
  }

  // Enter voegt de eerste gevonden oefening toe; Escape sluit (zie de view).
  toets(event) {
    if (event.key !== "Enter") return
    event.preventDefault()
    const eerste = this.optieTargets.find((optie) => !optie.hidden)
    const knop = eerste && eerste.querySelector("button")
    if (knop) knop.click()
  }

  sleep(event) {
    const knop = event.currentTarget
    event.dataTransfer.effectAllowed = "copy"
    event.dataTransfer.setData("application/x-oefening", knop.dataset.id)
    event.dataTransfer.setData("text/plain", knop.dataset.naam || "")
  }

  sleepEinde() {
    this.dispatch("sleepklaar")
  }

  sluit() {
    this.element.hidden = true
    this.dispatch("gesloten")
  }
}
